import { useTranslation as useI18nTranslation } from 'react-i18next';

import { Translation } from '@/i18n/config';
import { Path } from '@/types';

export const useTranslation = () => {
  const { t: i18nT, i18n } = useI18nTranslation();

  const t = (key: Path<Translation>) => i18nT(key);

  return { t, i18n };
};
